import script from "./jijia-insurance-tips.vue?vue&type=script&lang=ts&setup=true"
export * from "./jijia-insurance-tips.vue?vue&type=script&lang=ts&setup=true"

import "./jijia-insurance-tips.vue?vue&type=style&index=0&id=d650c742&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d650c742"]])

export default __exports__